
import global from 'Core/global';
import Block 	from 'Mixins/Block';
import { subscribe } from 'Mixins/pubsub';

export default Block('component-translate', {
	fn: {
		toggleActive (qComponent) {

			if (global.state.acceptedCookiesFunctional) {

				qComponent.addClass('component-translate__is-active');

			} else {

				qComponent.removeClass('component-translate__is-active');

			}

		}
	},
	onLoad (qComponent) {

		let toggleTranslateButtons = document.querySelectorAll('[data-translate]');

		const translatePanel = document.querySelector('.component-translate');

		if (!toggleTranslateButtons || !translatePanel) {

			return;

		}

		this.fn.toggleActive(qComponent);

		subscribe('component-cookie-update', () => {

			this.fn.toggleActive(qComponent);

		});

		// convert the nodelist in to an array so we can forEach on it. IE11 needs this.

		toggleTranslateButtons = Array.from(toggleTranslateButtons);

		toggleTranslateButtons.forEach( function (toggleTranslateButton) {

			toggleTranslateButton.addEventListener('click', function (e) {

				e.preventDefault();

				translatePanel.classList.toggle('component-translate__is-open');

			});

		});

	}

});
